import { Text } from '@unistocks/components/text/text';
import { GetProps, GetRef, ListItem, isWeb, styled, withStaticProperties } from 'tamagui';

const SelectTriggerFrame = styled(ListItem, {
  name: 'Input',
  render: 'div',
  unstyled: true,
  br: '$true',
  cursor: 'pointer',
  borderWidth: 1,
  size: '$5',
  px: '$3',
  py: '$2',
  backgroundColor: '$color1',
  scaleIcon: 1.4,

  ...(isWeb
    ? {
        tabIndex: 0
      }
    : {
        focusable: true
      }),

  hoverStyle: {
    backgroundColor: '$color001',
    borderColor: '$borderColorHover'
  },

  pressStyle: {
    backgroundColor: '$color005',
    borderColor: '$color6'
  },

  focusVisibleStyle: {
    outlineStyle: 'solid',
    outlineWidth: 2,
    outlineColor: '$outlineColor'
  },

  variants: {
    invalid: {
      true: {
        borderColor: '$danger',
        borderWidth: 2,

        pressStyle: {
          borderColor: '$danger',
          borderWidth: 2
        }
      }
    }
  } as const
});

const SelectTriggerText = styled(Text, {
  name: 'Input',
  size: '$5',
  bg: 'transparent',
  color: '$bodyFont',

  variants: {
    placeholder: {
      true: {
        color: '$placeholderColor'
      }
    }
  } as const,

  defaultVariants: {
    placeholder: false
  }
});

export type SelectTriggerProps = GetProps<typeof SelectTrigger>;
export type SelectTriggerRef = GetRef<typeof SelectTriggerFrame>;

export const SelectTrigger = withStaticProperties(SelectTriggerFrame, {
  Text: SelectTriggerText
});
